import { Component, EventEmitter, Input, IterableDiffers, OnChanges, OnInit, Output, SimpleChanges } from "@angular/core";
import { PageEvent } from "@angular/material/paginator";
import { Paginator } from "@sharedV11/classes/paginator/paginator";
import { DualListComponent } from "angular-dual-listbox";
import { HtmlElementParser, IChangedCustomElement } from "./html-elements";
import { FormControl, FormGroup } from "@angular/forms";
import { emit } from "process";
@Component({
  selector: "customan-html-elements",
  templateUrl: "./customan-html-elements.component.html",
  styleUrls: ["./customan-html-elements.component.scss"],
})
export class CustomanHtmlElementsComponent  extends DualListComponent implements OnInit, OnChanges {


  @Input() listLabel: string;
  @Input() copyList: any;
  @Input() filter: boolean;
  @Input() withPagination: boolean = false;
  @Input() paginator: Paginator;
  @Output() pageEvent: EventEmitter<PageEvent> = new EventEmitter<PageEvent>();
  @Output() emitMovedCentro: EventEmitter<void> = new EventEmitter<void>();
  @Input() totalLength: number = 0;
  // @Input() totalelements: any[];
  @Output() onTotalElementsChange: EventEmitter<any[]> = new EventEmitter<any[]>();
  @Input() baseElements: any[] = []; // Elementos base disponibles del JSON
  /** Si true, la dualidad se rige por la propiedad visible: visible true = añadidos (derecha), visible false = a añadir (izquierda). Al quitar solo se pone visible false. */
  @Input() useVisibleForDuality: boolean = false;

  private _totalelements: any[] = [];
  @Input()
  public set totalelements(elements: any[]) {
    console.log(`set elements: ${this._totalelements}`);
    this._totalelements = elements || [];
    this.elements = this.elementsHelper.parseElements(this._totalelements);
    this.initializeLists();
  }

  public get totalelements(): any[] {
    return this._totalelements;
  }

  listanmenu;

  elementsHelper: HtmlElementParser = new HtmlElementParser();

  element: any;
  elements: any[];
  properties: any[];
  myGroup: FormGroup = new FormGroup({
      elementsSelect: new FormControl(),
  });

  inputvalue: string;
  hasUnsavedChanges: boolean = false;
  originalElementState: any = null;

  verlista(nombre) {
    event.stopPropagation();
  }

  ngOnInit(): void {
    this.initializeLists();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['baseElements'] && !changes['baseElements'].firstChange) {
      this.initializeLists();
    }
    if (changes['totalelements'] && changes['totalelements'].firstChange === false && this.useVisibleForDuality) {
      this.initializeLists();
    }
  }

  moveItem(src: any, dst: any, callback?: () => void): void {
    if (this.useVisibleForDuality && src && src.pick && src.pick.length > 0) {
      const isMovingToConfirmed = (dst === this.confirmed);
      src.pick.forEach((item: any) => {
        const el = item._element;
        if (el) el.visible = isMovingToConfirmed;
      });
      src.pick = [];
      this.initializeLists();
      this.onTotalElementsChange.emit(this._totalelements);
      if (callback) callback();
      this.emitMovedCentro.emit();
      return;
    }

    // Implementar la lógica de mover elementos manualmente
    // Mover los elementos seleccionados de src.pick a dst.list
    if (src && src.pick && src.pick.length > 0 && dst && dst.list) {
      // Agregar los elementos seleccionados a la lista destino
      const itemsToMove = [...src.pick];
      dst.list = [...(dst.list || []), ...itemsToMove];
      
      // Remover los elementos movidos de la lista origen
      if (src.list) {
        src.list = src.list.filter((item: any) => {
          return !itemsToMove.some((picked: any) => {
            const itemId = this.resolveItemId(item);
            const pickedId = this.resolveItemId(picked);
            return itemId !== undefined && pickedId !== undefined && itemId === pickedId;
          });
        });
      }
      
      // Limpiar la selección
      src.pick = [];
      
      // Aplicar filtros
      if (src.list && src.list.length > 0) {
        this.onFilter(src);
      }
      if (dst.list && dst.list.length > 0) {
        this.onFilter(dst);
      }
    }
    
    // Actualizar totalelements basado en confirmed.list
    if (dst === this.confirmed) {
      // Se movió a confirmed (añadido)
      this.updateTotalelementsFromConfirmed();
    } else if (src === this.confirmed) {
      // Se movió desde confirmed (eliminado)
      this.updateTotalelementsFromConfirmed();
    }
    
    if (callback) {
      callback();
    }
    this.emitMovedCentro.emit();
  }
  
  private resolveItemId(item: any): any {
    if (!item) {
      return undefined;
    }
    // Intentar obtener el ID del elemento
    if (item._id !== undefined) {
      return item._id;
    }
    if (item._element && item._element.name) {
      return item._element.name;
    }
    if (item.name) {
      return item.name;
    }
    return undefined;
  }

  onDropConfirmed(event: DragEvent, targetIndex: number): void {
    event.preventDefault();
    event.stopPropagation();
    
    const draggedSiftIndex = parseInt(event.dataTransfer.getData('text/plain'));
    
    if (isNaN(draggedSiftIndex) || draggedSiftIndex === targetIndex) {
      return;
    }
    
    // Obtener los elementos reales de sift
    if (this.confirmed && this.confirmed.sift && this.confirmed.list) {
      const draggedItem = this.confirmed.sift[draggedSiftIndex];
      const targetItem = this.confirmed.sift[targetIndex];
      
      // Encontrar los índices reales en confirmed.list
      const draggedListIndex = this.confirmed.list.findIndex((item: any) => {
        const itemId = this.resolveItemId(item);
        const draggedId = this.resolveItemId(draggedItem);
        return itemId === draggedId;
      });
      
      const targetListIndex = this.confirmed.list.findIndex((item: any) => {
        const itemId = this.resolveItemId(item);
        const targetId = this.resolveItemId(targetItem);
        return itemId === targetId;
      });
      
      if (draggedListIndex === -1 || targetListIndex === -1 || draggedListIndex === targetListIndex) {
        return;
      }
      
      // Reordenar en confirmed.list
      const item = this.confirmed.list[draggedListIndex];
      this.confirmed.list.splice(draggedListIndex, 1);
      const newIndex = draggedListIndex < targetListIndex ? targetListIndex - 1 : targetListIndex;
      this.confirmed.list.splice(newIndex, 0, item);
      
      // Actualizar _totalelements con el nuevo orden
      const elementosAñadidos = this.convertFromDualListFormat(this.confirmed.list || []);
      this._totalelements = elementosAñadidos;
      
      // Emitir el cambio
      this.onTotalElementsChange.emit(this._totalelements);
      
      // Re-aplicar filtros
      this.onFilter(this.confirmed);
    }
  }

  onDragStartConfirmed(event: DragEvent, index: number): void {
    event.dataTransfer.effectAllowed = 'move';
    event.dataTransfer.setData('text/plain', index.toString());
    
    // Agregar clase visual durante el arrastre
    if (event.target) {
      (event.target as HTMLElement).classList.add('dragging');
    }
  }

  onDragEndConfirmed(confirmed: any, event: DragEvent): void {
    this.dragEnd(confirmed);
    const target = event.target as HTMLElement;
    if (target?.classList) {
      target.classList.remove('dragging');
    }
  }

  moveItemToConfirmed(): void {
    this.moveItem(this.available, this.confirmed);
  }

  moveItemFromConfirmed(): void {
    this.moveItem(this.confirmed, this.available);
  }

  private updateTotalelementsFromConfirmed(): void {
    // Convertir los elementos de confirmed.list de vuelta al formato original
    const elementosAñadidos = this.convertFromDualListFormat(this.confirmed.list || []);
    // Actualizar totalelements
    this._totalelements = elementosAñadidos;
    this.elements = this.elementsHelper.parseElements(this._totalelements);
    
    // Emitir el cambio
    this.onTotalElementsChange.emit(this._totalelements);
    
    // Re-inicializar las listas para actualizar available
    this.initializeLists();
  }

  private initializeLists(): void {
    // Esperar a que available y confirmed estén inicializados
    if (!this.available || !this.confirmed) {
      setTimeout(() => this.initializeLists(), 100);
      return;
    }

    if (this.useVisibleForDuality && this._totalelements && this._totalelements.length > 0) {
      const disponibles = this._totalelements.filter((e: any) => e.visible !== true);
      const añadidos = this._totalelements.filter((e: any) => e.visible === true);
      this.available.list = this.convertToDualListFormat(disponibles);
      this.available.sift = Array.isArray(this.available.list) ? [...this.available.list] : [];
      if (this.available.list.length > 0) this.onFilter(this.available);
      this.confirmed.list = this.convertToDualListFormat(añadidos);
      this.confirmed.sift = Array.isArray(this.confirmed.list) ? [...this.confirmed.list] : [];
      if (this.confirmed.list.length > 0) this.onFilter(this.confirmed);
      return;
    }
    
    // Convertir elementos base disponibles al formato DualListComponent
    const elementosDisponibles = this.convertToDualListFormat(
      this.getAvailableElements(this.baseElements, this._totalelements)
    );
    
    // Convertir elementos añadidos al formato DualListComponent
    const elementosAñadidos = this.convertToDualListFormat(this._totalelements);
    
    // Inicializar available con elementos disponibles
    this.available.list = elementosDisponibles || [];
    // Sincronizar sift con list para que la vista izquierda se actualice cuando list queda vacío (ej. al elegir todos)
    this.available.sift = Array.isArray(this.available.list) ? [...this.available.list] : [];
    if (this.available.list.length > 0) {
      this.onFilter(this.available);
    }
    
    // Inicializar confirmed con elementos añadidos
    this.confirmed.list = elementosAñadidos || [];
    // Sincronizar sift con list para que la vista (*ngFor sobre confirmed.sift) se actualice
    // cuando list queda vacío (onFilter del base no actualiza sift a [] en ese caso)
    this.confirmed.sift = Array.isArray(this.confirmed.list) ? [...this.confirmed.list] : [];
    if (this.confirmed.list.length > 0) {
      this.onFilter(this.confirmed);
    }
  }

  private getAvailableElements(baseElements: any[], addedElements: any[]): any[] {
    if (!baseElements || baseElements.length === 0) {
      return [];
    }

    if (!addedElements || addedElements.length === 0) {
      return baseElements;
    }

    const countByName: Record<string, number> = {};
    addedElements.forEach(elem => {
      const key = elem.name != null ? String(elem.name) : '';
      countByName[key] = (countByName[key] || 0) + 1;
    });
    
    const usedByName: Record<string, number> = {};
    return baseElements.filter(elem => {
      const key = elem.name != null ? String(elem.name) : '';
      const added = countByName[key] || 0;
      const used = usedByName[key] || 0;
      const baseWithSameName = baseElements.filter(e => (e.name != null ? String(e.name) : '') === key).length;
      const remaining = baseWithSameName - added;
      if (used >= remaining) {
        return false;
      }
      usedByName[key] = used + 1;
      return true;
    });
  }

  private convertToDualListFormat(elements: any[]): any[] {
    if (!elements || elements.length === 0) {
      return [];
    }
    return elements.map((elem, idx) => {
      const name = elem.name || elem.label || `Elemento ${idx + 1}`;
      const id = `${elem.name || 'elem'}_${idx}`;
      return {
        _id: id,
        _name: name,
        _element: elem // Guardar el elemento original para poder recuperarlo
      };
    });
  }

  private convertFromDualListFormat(dualListItems: any[]): any[] {
    if (!dualListItems || dualListItems.length === 0) {
      return [];
    }
    
    return dualListItems.map(item => {
      // Si tiene _element, usar ese (es el elemento original)
      if (item._element) {
        return item._element;
      }
      // Si no, intentar reconstruir desde los datos disponibles
      return item;
    });
  }

  async emitPageEvent(event: PageEvent) {
    await this.pageEvent.emit(event);
  }

  constructor(differs: IterableDiffers) {
    super(differs);
  }

  itemSelected(e: any) {
    // cuando iniciamos aun no hemos parseado el elemento
    // ver si podemos ponerlo en el nginit
    if(!this.elements)
      this.elements = this.elementsHelper.parseElements(this.totalelements);
    // seleccion
    this.element = this.elements[e];
  }

  onItemSelectedFromConfirmed(item: any, event?: any, idx?: number): void {
    if (!item) return;
    
    // Verificar si el item ya está seleccionado
    const isCurrentlySelected = this.isItemSelected(this.confirmed?.pick || [], item);
    
    // Si el item ya está seleccionado, deseleccionarlo y cerrar el editor
    if (isCurrentlySelected) {
      // Si es el item que está siendo editado, cerrar el editor (comparar por nombre del campo, no por type)
      const storedElement = this.element?.idx !== undefined && this._totalelements?.[this.element.idx];
      const isSameItem = !!storedElement && !!item._element && item._element.name === storedElement.name;
      if (this.element && isSameItem) {
        // Si hay cambios sin guardar, preguntar antes de cerrar
        if (this.hasUnsavedChanges) {
          if (!confirm('Tienes cambios sin guardar. ¿Deseas descartarlos?')) {
            return;
          }
        }
        this.closeEditor();
      }
      // Deseleccionar el item
      this.selectItem(this.confirmed.pick, item);
      return;
    }
    
    // Si hay cambios sin guardar en otro elemento, preguntar antes de cambiar
    if (this.hasUnsavedChanges && this.element) {
      if (!confirm('Tienes cambios sin guardar. ¿Deseas descartarlos?')) {
        return;
      }
      this.cancelChanges();
    }
    
    // Seleccionar el nuevo item
    this.selectItem(this.confirmed.pick, item);
    
    // Abrir el editor para el item seleccionado
    if (item && item._element) {
      const elementoOriginal = item._element;
      const elementosParseados = this.elementsHelper.parseElements([elementoOriginal]);
      if (elementosParseados && elementosParseados.length > 0) {
        this.element = elementosParseados[0];
        // Guardar el estado original para poder cancelar cambios
        this.originalElementState = JSON.parse(JSON.stringify(this.element));
        this.hasUnsavedChanges = false;
        
        // Asegurar que elements esté inicializado
        if (!this.elements) {
          this.elements = this.elementsHelper.parseElements(this._totalelements);
        }
        // Buscar el índice del elemento en elements para poder actualizarlo
        const idxElement = this._totalelements.findIndex(e => e.name === elementoOriginal.name);
        if (idxElement !== -1) {
          this.element.idx = idxElement;
        }
      }
    }
  }
  
  closeEditor(): void {
    this.element = null;
    this.hasUnsavedChanges = false;
    this.originalElementState = null;
  }
  
  selectNoneConfirmed(): void {
    // Si hay cambios sin guardar, preguntar antes de cerrar
    if (this.hasUnsavedChanges && this.element) {
      if (!confirm('Tienes cambios sin guardar. ¿Deseas descartarlos?')) {
        return;
      }
    }
    // Cerrar el editor antes de deseleccionar
    this.closeEditor();
    // Llamar al método original de selectNone
    if (this.confirmed) {
      this.selectNone(this.confirmed);
    }
  }
  
  onItemSelectedFromAvailable(item: any): void {
    // Si hay cambios sin guardar, preguntar antes de cambiar
    if (this.hasUnsavedChanges && this.element) {
      if (!confirm('Tienes cambios sin guardar. ¿Deseas descartarlos?')) {
        return;
      }
      this.cancelChanges();
    }
    // Cerrar el editor si está abierto
    this.closeEditor();
    // Seleccionar el item de available
    if (item) {
      this.selectItem(this.available.pick, item);
    }
  }

  choosenElement(e) {
    this.element = this.elements.find(elem => elem.name == e);
  }

  onPropertyChanged(event: IChangedCustomElement) {
    if (this.element && this.element.properties) {
      this.element.properties[event.idx].value = event.value;
      const changedProp = this.element.properties[event.idx];
      if (changedProp && changedProp.name === "optionsJSON" && Array.isArray(event.value)) {
        const optionsProp = this.element.properties.find((p: any) => p.name === "options");
        if (optionsProp) {
          optionsProp.value = (event.value || []).map((item: any) => {
            if (item == null) return null;
            return typeof item === "object" && item.value != null ? item.value : item;
          }).filter((v: any) => v != null && v !== "");
        }
      }
      this.hasUnsavedChanges = true;
    }
  }

  saveChanges(): void {
    if (!this.element || !this.hasUnsavedChanges) {
      return;
    }
    
    // Actualizar el elemento en totalelements
    if (this.element.idx !== undefined && this.element.idx !== -1 && this.element.idx < this._totalelements.length) {
      const elementosExportados = this.elementsHelper.exportElements([this.element]);
      if (elementosExportados && elementosExportados.length > 0) {
        // Actualizar el elemento en _totalelements
        Object.assign(this._totalelements[this.element.idx], elementosExportados[0]);
      }
    }
    
    // Actualizar también en confirmed.list para reflejar cambios en la UI
    const confirmedItem = this.confirmed?.list?.find((item: any) => {
      const itemId = this.resolveItemId(item);
      const elementId = this.element.name;
      return itemId === elementId;
    });
    
    if (confirmedItem && confirmedItem._element) {
      const elementosExportados = this.elementsHelper.exportElements([this.element]);
      if (elementosExportados && elementosExportados.length > 0) {
        confirmedItem._element = elementosExportados[0];
        confirmedItem._name = elementosExportados[0].name || elementosExportados[0].label || confirmedItem._name;
      }
    }
    
    // Guardar el nuevo estado como original
    this.originalElementState = JSON.parse(JSON.stringify(this.element));
    this.hasUnsavedChanges = false;
    
    // Emitir el cambio con totalelements actualizado
    this.onTotalElementsChange.emit(this._totalelements);
    
    // Re-inicializar las listas para reflejar cambios
    this.initializeLists();

    // Cerrar el panel y deseleccionar el ítem para que la vista "retroceda"
    const elementName = this.element?.name;
    this.closeEditor();
    if (elementName && this.confirmed?.list && this.confirmed?.pick) {
      const currentItem = this.confirmed.list.find((item: any) => this.resolveItemId(item) === elementName);
      if (currentItem) {
        this.selectItem(this.confirmed.pick, currentItem);
      }
    }
  }

  cancelChanges(): void {
    if (!this.element || !this.originalElementState) {
      return;
    }
    
    // Restaurar el elemento a su estado original
    this.element = JSON.parse(JSON.stringify(this.originalElementState));
    this.hasUnsavedChanges = false;
    
    // Opcional: cerrar el panel de edición
    // this.element = null;
  }

  dynamicInputChange(event: any ,element_name: any, element_type:string, idx:string = "") {
    // const exist = this.findItemIndex(this.available.sift, element_name,element_name);
    //console.log(event, element_name, element_type);
    let element_value = ''
    if (element_type === 'boolean')
      element_value = event.checked;
    else
      element_value = event.currentTarget.value;
    // const add = element_name + ":" + element_value;
    // if (exist !== -1)
    //   this.available.sift[exist] = this.available.sift[exist].name + "|" + add
    // else {
    //   const htmlcontrol = { _id: element_name,  _name: add };
    //   this.available.sift.push(htmlcontrol);
    // }

    const property = this.element.properties.findIndex(p => p.name == element_name);
    //actualizo solo la property cambiada
    this.element.properties[property].value = element_value;

    this.addAndConfirmElement();

  }

  addAndConfirmElement() {

    const itemName = `${this.element.idx + 1}-${this.element.name}`
    const itemId = `${this.element?.id ? this.element.id : this.element.idx }`

    let item = { 
        _id: itemId, 
        _name: itemName
    };

    // sino existe subo el elemento
    if (!this.element?.id){
      this.available.sift.push(item);
      this.element.id = this.element.idx;
    }

    this.selectItem(this.available.pick, item);
    this.moveItem(this.available, this.confirmed);
    this.emitMovedCentro.emit();
  }

  executeCopy(text) {
    var input = document.createElement("textarea");
    document.body.appendChild(input);
    input.value = text;
    input.focus();
    input.select();
    document.execCommand("Copy");
    input.remove();
  }

  clipboard(url, params) {
 
    this.executeCopy(url + params);
    
  }
}
